package io.eqoty.secretk.types.proto

/***
 * Reference:
 * https://github.com/scrtlabs/SecretNetwork/blob/master/third_party/proto/cosmos/bank/v1beta1/tx.proto
 */
@kotlinx.serialization.Serializable
class MsgSendResponseProto : MsgProto()